import { buildCloudinaryTransforms } from '#app/utilities/cloudinaryTransforms/buildCloudinaryTransforms.js';
import { type CloudinaryTransformOptions } from '#app/utilities/cloudinaryTransforms/types.js';

export const getContraImageUrl = (
  imageUid: string,
  ...transformOptions: CloudinaryTransformOptions[]
): string => {
  return [
    'https://media.contra.com/image/upload',
    buildCloudinaryTransforms(...transformOptions),
    imageUid,
  ]
    .filter(Boolean)
    .join('/');
};
